import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "../../Config.jsx";
import Helper from "../../Helper.jsx"

import Localization from "../../Localization.jsx"
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import ReactAudioPlayer from 'react-audio-player';

import {
  Chip,
  Avatar,
  Icon,
  Button,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';

import {
  grey,
  green,
} from '@material-ui/core/colors'

class LocaleOverviewStageElement extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  parsePayload(payload) {
    let result = null;
    try {
      result = JSON.parse(payload);
    } catch (err) {
      console.log(err);
    }
    return result;
  }

  mcAnswer() {
    if (this.props.playbackData.kind != "2") {
      return;
    }
    let payload = this.parsePayload(this.props.playbackData.payload);
    if (payload == null) {
      return (<div/>)
    }
    let ansArr = payload['ans_arr'];
    return (
      <div>
        {ansArr.map( (row, i) => {
          let colorBG = grey[600]; // grey = wrong answer // green = right answer
          let resultBG = colorBG;
          if (row.is_correct) {
            resultBG = green[600];
          }

          return (
            <Chip
              key={i}
              style={{margin:"6px 12px 0 0", background:resultBG, color:'White'}}
              avatar={
                <Avatar style={{background:resultBG}}>
                  <Icon style={{color:'White'}}>{row.is_correct > 0 ? "check_circle": "highlight_off"}</Icon>
                </Avatar>
              }
              label={row.text}
            />
          )
        })}
      </div>
    );
  }

  portal() {
    if (this.props.playbackData.kind != "3") {
      return;
    }
    let payload = this.parsePayload(this.props.playbackData.payload);
    if (payload == null) {
      return (<div/>)
    }
    let portal_arr = payload['portal_arr'];
    return (
      <div>
        {portal_arr.map( (row, i) => {
          if (row.stage_id > 0) {
            return (
              <Chip
                key={i}
                style={{margin:"6px 12px 0 0"}}
                label={this.getStageNameByStageId(row.stage_id)}
              />
            )
          }
        })}
      </div>
    );
  }

  getStageNameByStageId(stage_id) {
    let stageList = this.props.parent.props.parent.state.stageList;
    for (let i = 0; i < stageList.length; i++) {
      if (stageList[i].id == stage_id) {
        return stageList[i].stage_name;
      }
    }
  }

  attachmentClicked(fileId) {
    if (fileId > 0) {
      let requestObj = {
        file_id: fileId,
      };
      this.props.root.refs.API.request("get_file_info", requestObj, this.getFileInfoOK, this.getFileInfoFailed);
    }
  }

  getFileInfoOK(res) {
    let fileData = res.body['result'];
  }

  getFileInfoFailed(err) {
    console.log("get file info failed");
  }

  playbackItem(playbackData) {
    return (
      <ListItem key={playbackData.id} alignItems="flex-start" style={{
        backgroundColor: 'white',
        borderRadius: '4px',
        marginBottom: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
          transform: 'translateY(-1px)'
        }
      }}>
        <ListItemAvatar>
          <Avatar style={{
            backgroundColor: '#2196f3',
            color: 'white'
          }}>
            <Icon>{Config.GET_PLAYBACK_CONFIG(parseInt(playbackData.kind))['icon']}</Icon>
          </Avatar>
        </ListItemAvatar>
        <ListItemText style={{
          '& .MuiTypography-root': {
            fontSize: '0.95rem',
            lineHeight: '1.5'
          }
        }}>
          <LocaleOverviewStageElement root={this.props.root} parent={this} playbackData={playbackData}/>
        </ListItemText>
      </ListItem>
    )
  }

  render() {
    let playbackData = this.props.playbackData;
    let payload = this.parsePayload(playbackData.payload);
    let fileId = null;
    let fileKind = -1;
    let filePath = "";
    if (payload != null) {
      fileId = payload['file_id'];
      if (fileId != null) {
        fileKind = payload['kind'];
        filePath = Config.BASE_PATH() + this.props.parent.props.parent.state.filePathDict[fileId];
      }
    }
    return (
      <div>
        {Helper.fToHHMMSS(parseInt(playbackData.trigger_time)) + " - " + playbackData.content}
        <Switch condition={parseInt(playbackData.kind)}>
          <Case value={2}>
            {this.mcAnswer()}
          </Case>
          <Case value={3}>
            {this.portal()}
          </Case>
        </Switch>
        <If condition={fileId != null && fileKind == "2"}>
          <Then>
            <div style={{margin:'6px 0 0 0'}}>
              <img
                style={{borderRadius:4, maxHeight:"33%", maxWidth:"33%"}}
                src={filePath}
              />
            </div>
          </Then>
        </If>
        <If condition={fileId != null && fileKind == "1"}>
          <Then>
            <div style={{margin:'6px 0 0 0'}}>
              <ReactAudioPlayer
                controls
                src={filePath}
              />
            </div>
          </Then>
        </If>
      </div>
    )
  }
}

export default LocaleOverviewStageElement;
